"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.recertFormToPayloadDataHandler = recertFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function recertFormToPayloadDataHandler(data) {
    var _a, _b, _c, _d, _e;
    const now = (0, dayjs_1.default)();
    return {
        form: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ visitDate: (_a = data.pastAppointment) === null || _a === void 0 ? void 0 : _a.visitDate }, (((_b = data.pastAppointment) === null || _b === void 0 ? void 0 : _b.visitStartTime) && {
            visitTimeIn: (_c = data.pastAppointment) === null || _c === void 0 ? void 0 : _c.visitStartTime,
        })), (((_d = data.pastAppointment) === null || _d === void 0 ? void 0 : _d.visitEndTime) && {
            visitTimeOut: (_e = data.pastAppointment) === null || _e === void 0 ? void 0 : _e.visitEndTime,
        })), (data.physicianName && { physicianName: data.physicianName })), (data.contactPersonAtDoctorOffice && {
            contactPersonAtDoctorOffice: data.contactPersonAtDoctorOffice,
        })), { recertFrequency: data.recertFrequency }), (data.aideRequired && { aideRequired: data.aideRequired })), (data.frequencyForAide && { frequencyForAide: data.frequencyForAide })), { offSet: now.utcOffset() }),
    };
}
